import Tabs from '@components/ui/Tabs';
import { useLocation, useNavigate } from 'react-router-dom';

const tabs = [
  {
    label: 'Transactions',
    value: 'transactions',
  },
  {
    label: 'Statements',
    value: 'statements',
  },
];

const BankingTabs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentTab = location.pathname.split('/').pop();
  const onTabSelect = (tab: string) => {
    navigate(`../${tab}`);
  };

  return (
    <Tabs
      className="my-4 w-full"
      selected={currentTab!}
      tabs={tabs}
      onSelect={onTabSelect}
    />
  );
};

export default BankingTabs;
